import type { Agent, Issue, IssueWorkMode } from "@paperclipai/shared";
/** Ephemeral view model; never persisted until first send or upload. */
export function agentChatDraft(
  agent: Agent,
  workMode: IssueWorkMode = "standard",
): Issue {
  return {
    id: `chat:${agent.id}`,
    companyId: agent.companyId,
    title: `Chat with ${agent.name}`,
    conversationAgentId: agent.id,
    conversationUserId: "draft",
    conversationState: "waiting",
    status: "in_review",
    workMode,
    priority: "medium",
    reviewPolicy: null,
    projectId: null,
    projectWorkspaceId: null,
    goalId: null,
    parentId: null,
    description: null,
    assigneeAgentId: agent.id,
    assigneeUserId: null,
    checkoutRunId: null,
    executionRunId: null,
    executionAgentNameKey: null,
    executionLockedAt: null,
    createdByAgentId: null,
    createdByUserId: null,
    responsibleUserId: null,
    issueNumber: null,
    identifier: null,
    requestDepth: 0,
    billingCode: null,
    assigneeAdapterOverrides: null,
    executionWorkspaceId: null,
    executionWorkspacePreference: null,
    executionWorkspaceSettings: null,
    startedAt: null,
    completedAt: null,
    cancelledAt: null,
    hiddenAt: null,
    createdAt: new Date(0),
    updatedAt: new Date(0),
    documentSummaries: [],
    labels: [],
  };
}
